module.exports = __webpack_public_path__ + "img/23.dd333023.png";